<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <a class="btn btn-primary" href="#" data-bs-toggle="modal" data-bs-target="#AddPaiementModal">
          <i class="fa fa-plus-circle"></i>
          Ajouter un paiement
        </a>
      </div>

        <div class="d-flex align-items-center">
        <button class="btn btn-belgium px-4 py-2">
          Montant total : {{ totalMontant }}
        </button>

      </div>
    </div>
    <div class="col-md-12">
      <div class="row d-flex justify-content-center align-items-center text-center">

        <div class="col-md-3 d-flex justify-content-center">
          <div class="form-group mb-15 mb-sm-20 w-100">
          <label class="d-block text-black fw-semibold mb-10">
              Date de début 
            </label>
          <input type="date" v-model="dateDebut"
            class="form-control me-2" placeholder="Date début" />
        </div>
      </div>

        <div class="col-md-3 d-flex justify-content-center">
          <div class="form-group mb-15 mb-sm-20 w-100">
          <label class="d-block text-black fw-semibold mb-10">
              Date de fin 
            </label>
          <input type="date" v-model="dateFin"
            class="form-control me-2" placeholder="Date fin" />
        </div>
      </div>

        <div class="col-md-3 d-flex justify-content-center">

          <form class="search-box position-relative d-flex">
            <input type="text" v-model="motCle"
              class="form-control " placeholder="Rechercher une facture" />
            <button type="submit" class="bg-transparent text-primary transition p-0 border-0 ms-2">
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
        </div>

      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">REFERENCE</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">MONTANT</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">FACTURE</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">DATE DE
                PAIEMENT</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">STATUT</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end">
                Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(paiement, index) in Paiements" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">{{ paiement.reference }}</td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">{{ paiement.montant }}</td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">{{
                paiement?.paiementFactures?.[0]?.facture?.reference }}</td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">{{ format_date(paiement.date_paiement) }}</td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="getStatutBadge(paiement.statut)?.badgeClass">{{ getStatutBadge(paiement.statut)?.text
                }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black pe-0 text-end">
                <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false">Actions</button>
                <ul class="dropdown-menu dropdown-block" data-popper-placement="bottom-start">
                  <li>
                    <a @click="openNewWindow(paiement)" type="button" class="dropdown-item d-flex align-items-center">
                      <i class="flaticon-send lh-1 me-8 position-relative top-1"></i> Reçu de paiement
                    </a>
                  </li>
              
                <!--<li class="dropdown-item d-flex align-items-center">
                    <a href="javascript:void(0);"
                      @click="suppression(paiement.id, Paiements, 'Paiements', 'Le ' + paiement.id)">
                      <i class="flaticon-delete lh-2 me-8 position-relative top-1"></i> Supprimer
                    </a>
                  </li>--> 
    

                  <li v-if="paiement.statut !== 'Payé' && paiement.statut !== 'ANNULE'">
                      <a href="javascript:void(0);" data-bs-target="#create-task" data-bs-toggle="modal"
                        @click="openModal(paiement.id)"
                        class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-close lh-1 me-8 position-relative top-1"></i> Annuler
                      </a>
                    </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Total amount button -->
      <div class="d-flex justify-content-between mt-3">

        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>

  <div class="modal fade" id="create-task" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Voulez-vous annuler cette facture ?</h6>
              <button type="button" id="close-modal" class="btn-close" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div class="modal-body px-4">
              <Form ref="depensesForm" @submit="addPaiements" :validation-schema="paiementsSchema">
                <div class="row gy-2">
                  <div class="col-md-4-3">
                    <label class="d-block fw-semibold mb-10">
                      Motif<span class="text-danger">*</span>
                    </label>
                    <Field name="motifAnnuler" as="textarea" placeholder="Entrer l'observation"
                      class="form-control shadow-none rounded-0 text-black" />
                    <ErrorMessage name="motifAnnuler" class="text-danger" />
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary">Annuler</button>
                  <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                  aria-label="Close">
                    Fermer
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>

  <AddPaiementModal @getAllPaiements="rechercher" :id="idpaiement" @openmodal="showModalEdite" />
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import AddPaiementModal from "./AddPaiementModal.vue";
import ApiService from "@/services/ApiService";
import { format_date, showModal, suppression, success ,separateur, error, getUrlApiForFiles, dateActuelle, } from "@/utils/utils";
import { Paiement } from "@/models/Paiement";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Swal from "sweetalert2";
import axios from "axios";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from 'yup';

export default defineComponent({
  name: "ListePaiement",
  components: {
    AddPaiementModal,
    PaginationComponent,
    Form,
    Field,
    ErrorMessage,

  },
  setup: () => {

    onMounted(() => {
      actionRecherche();

    });
    const Paiements = ref<Array<any>>([]);
    const idpaiement = ref(0);
    const paiement = ref<Paiement>();
    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const motCle = ref("");
    const dateFin = ref(dateActuelle());
    const dateDebut = ref(dateActuelle());
    const totalMontant = ref();
    const paiementii = ref();
    const paiementsForm = ref(null);

    const openModal = (id: number) => {
      paiementii.value = id;
    };

    const paiementsSchema = Yup.object().shape({
      motifAnnuler: Yup.string().required("Le motif est obligatoire"),
    });

    const handlePaginate = async ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        await actionRecherche();
      } catch (error) {
        //
      }
    };
    
    const  rechercher = async() =>{
      await actionRecherche();
    }

    const getStatutBadge = (statut: string | null) => {
      if (statut === "SUCCESS" || statut === "RAS") {
        return {
          text: "Payé",
          badgeClass: "badge bg-success text-white",
        };
      } else if (statut === "ANNULE") {
        return {
          text: "Annulé",
          badgeClass: "badge bg-danger text-white",
        };
      }
    };

    const addPaiements = async (values, { resetForm }) => {
      values["id"] = paiementii.value;
      values["statut"] = "ANNULE";
      ApiService.put("/AnnulePaiements/" + values.id, values)
        .then(({ data }) => {
          console.log('paiement', data);
          if (data.code === 200) {
            success(data.message);
            resetForm();
            triggerButtonClick("close-modal");
            actionRecherche();

          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    const annulerPaiement = (id: number, reference: string) => {
      Swal.fire({
        title: "Confirmation",
        text: `Voulez-vous vraiment annuler le paiement ${reference} ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Annuler",
        cancelButtonText: "Retour"
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.put(`/AnnulePaiements/${id}`, {})
            .then(async ({ data }) => {
              Swal.fire({
                title: "Annulé",
                text: "La paiement a été annulée avec succès.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
              });
              await actionRecherche()
            })
            .catch(({ response }) => {
              Swal.fire({
                title: "Erreur",
                text: response.data.message || "Une erreur est survenue.",
                icon: "error",
                confirmButtonText: "Ok"
              });
            });
        }
      });
    };

    function triggerButtonClick(buttonId: string) {
      const button = document.getElementById(buttonId) as HTMLButtonElement;
      if (button) {
        button.click(); // Simule un clic
      } else {
        console.error(`Button with ID "${buttonId}" not found.`);
      }
    }

    function moddifier(EditPaiement: Paiement) {
      idpaiement.value = EditPaiement.id;
    }

    function showModalEdite(el) {
      showModal(el);
      idpaiement.value = 0;
    }

    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };

    function openNewWindow(data: any, dossier = "Recu") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));
    }

    const actionRecherche = async (page = 1, limi = 10, searchTerm = "") => {
      const element = {
        dateDebut:(dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
        dateFin: (dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
        motCle: motCle.value,
        recherche: motCle.value,
        page: page,
        totalPages: totalPages.value,
        limit: limi,
        totalElements: totalElements.value,
        mot: searchTerm,
      };
      try {
        const response = await axios.post("all/paiements", element);
        Paiements.value = response.data.data.data;
        totalPages.value = response.data.data.totalPages;
        limit.value = response.data.data.limit;
        totalElements.value = response.data.data.totalElements;
        totalMontant.value = separateur(response.data.data.montant) + " (FCFA)";
      } catch (error) {
        // error("Erreur");
      }
    };
    watch(motCle, async (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      motCle.value = newValue;
      await actionRecherche(page.value, limit.value);
    });
    watch(dateFin, async(newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      dateFin.value = newValue;
      await actionRecherche(page.value, limit.value);
    });
    watch(dateDebut, async(newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      dateDebut.value = newValue;
      await actionRecherche(page.value, limit.value);
    });
    return {
      actionRecherche,
      openNewWindow,
      suppression,
      checkPermission,
      Paiements,
      format_date,
      idpaiement,
      moddifier,
      showModalEdite,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      searchTerm,
      separateur,
      rechercher,
      annulerPaiement,
      getStatutBadge,
      dateDebut,
      dateFin,
      totalMontant,
      motCle,
      addPaiements,
      openModal,
      paiementsSchema
    };
  },
});
</script>